// extracted by mini-css-extract-plugin
export var container = "socialMedia-module--container--uqIlV";
export var firstImage = "socialMedia-module--firstImage--R0VkR";
export var secondImage = "socialMedia-module--secondImage--q0pxN";
export var thirdImage = "socialMedia-module--thirdImage--8vrwW";